/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AITranslate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.81 11.363q-.633 0-.956-.322-.309-.323-.376-.848H4.41a1.78 1.78 0 0 1-.74.982q-.525.35-1.345.35-1.062 0-1.694-.552Q0 10.41 0 9.428 0 8.42.74 7.894q.753-.538 2.299-.538H4.37v-.538q0-1.411-1.492-1.412-.673 0-1.09.27-.416.255-.699.685l-.874-.713q.297-.564.995-.968.7-.417 1.802-.417 1.318 0 2.071.632t.753 1.83v3.482h.874v1.156zm-3.067-.914q.712 0 1.17-.323t.457-.833V8.284H3.066q-1.587 0-1.587.955v.269q0 .47.336.712.337.23.928.229M10.217 3.483h5.064v1.185h-5.064zm.01 2.42h5.105v1.155h-5.105zm-.05 2.4h5.084V9.48h-5.085zm-.79-4.82h1.245v3.352c0 1.762-.274 4.244-1.985 5.682-.183-.253-.679-.709-.942-.87 1.54-1.308 1.681-3.262 1.681-4.812zm5.327 0H16v7.495c0 .719-.172 1.083-.638 1.286-.486.213-1.205.233-2.259.233a4.6 4.6 0 0 0-.506-1.276c.719.04 1.56.03 1.803.03.233-.01.314-.08.314-.294z" /></svg>;
}
;